import Home from "./Home";
export default class Menu extends Home {
  constructor(page) {
    super();
    this.page = page;
  }

  initMenus() {
    this._initEntryTabs();
    this._initMenuSwipers();
  }

  _initEntryTabs() {
    const entriesTabs = this.page.querySelectorAll(".js-menu-tabs");
    entriesTabs?.forEach(entrytab => {
      const tabs = entrytab.querySelectorAll('[role="tab"]');
      const tabList = entrytab.querySelector('[role="tablist"]');
      const swiperThumb = entrytab.querySelector(".js-tabs-controller-scrollbar-thumb");
      const btnNext = entrytab.querySelector(".js-tabs-controller-button-next");
      const btnPrev = entrytab.querySelector(".js-tabs-controller-button-prev");
      
      // Add a click event handler to each tab
      tabs?.forEach((tab) => {
        tab.addEventListener("click", this._changeTabs.bind(this));
      }); 
  
      if (swiperThumb) {
        swiperThumb.style.width = `${tabs[0].offsetWidth}px`;
      }
    
      // Enable arrow navigation between tabs in the tab list
      let tabFocus = 0;
    
      // CODE BELOW COULD BE DRYER...
      tabList?.addEventListener("keydown", (e) => {
        // Move right
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          tabs[tabFocus].setAttribute("tabindex", -1);
          
          if (e.key === "ArrowRight") {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
          
            // Move left
          } else if (e.key === "ArrowLeft") {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }
    
          tabs[tabFocus].setAttribute("tabindex", 0);
          tabs[tabFocus].focus();
        }
      });
      
      btnNext?.addEventListener("click", (e) => {
        tabs[tabFocus].setAttribute("tabindex", -1);
        tabFocus++;
        if (tabFocus >= tabs.length) {
          tabFocus = 0;
        }
        tabs[tabFocus].click();
      });
  
      btnPrev?.addEventListener("click", (e) => {
        tabs[tabFocus].setAttribute("tabindex", -1);
        tabFocus--;
        if (tabFocus < 0) {
          tabFocus = tabs.length - 1;
        }
        tabs[tabFocus].click();
      });
      // CODE ABOVE COULD BE DRYER...
    });
  }

  _changeTabs(e) {
    const target = e.target;
    const parent = target.closest(".tabs-controller");
    const grandparent = parent.closest(".js-menu-tabs");
  
    // Remove all current selected tabs
    parent
      .querySelectorAll('[aria-selected="true"]')
      .forEach((t) => t.setAttribute("aria-selected", false));
  
    // Set this tab as selected
    target.setAttribute("aria-selected", true);
  
    // Hide all tab panels
    grandparent
      .querySelectorAll('[role="tabpanel"]')
      .forEach((p) => p.setAttribute("hidden", true));
  
    // Show the selected panel
    grandparent.parentNode
      .querySelector(`#${target.getAttribute("aria-controls")}`)
      .removeAttribute("hidden");
  }

  _initMenuSwipers() {
    const swipers = this.page.querySelectorAll(".js-swiper-menu-list-controller");
    swipers?.forEach(swiper => {
      const swiperThumb = new Swiper(swiper, {
        loop: false,
        spaceBetween: 10,
        grabCursor: true,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true, 
        scrollbar: {
          el: swiper.querySelector(".swiper-scrollbar"),
          hide: false,
        },
      });

      const swiperMenu = new Swiper(swiper.nextElementSibling, {
        loop: false,
        spaceBetween: 20,
        autoHeight: true,
        grabCursor: true,
        thumbs: {
          swiper: swiperThumb,
        },  
        navigation: {
          nextEl: swiper.querySelector(".js-swiper-button-next"),
          prevEl: swiper.querySelector(".js-swiper-button-prev")
        },
      });
    });
  }
}